var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-tabs',{staticStyle:{"z-index":"2"},attrs:{"alignment":"center"}},[_c('vs-tab',{attrs:{"icon":"account_circle","label":"Minhas Pré-Matrículas"}},[_c('MyPreRegistrations')],1),_c('vs-tab',{attrs:{"icon":"dashboard","label":"Vencimentos no Mês"}},[_c('InstallmentsMonth')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }